import { render, staticRenderFns } from "./RedPacketEdit.vue?vue&type=template&id=6b698876&scoped=true&"
import script from "./RedPacketEdit.vue?vue&type=script&lang=js&"
export * from "./RedPacketEdit.vue?vue&type=script&lang=js&"
import style0 from "./RedPacketEdit.vue?vue&type=style&index=0&id=6b698876&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b698876",
  null
  
)

export default component.exports